import StatusTag from 'components/common/StatusTag';
import Check from 'components/icons/accent/Check';
import Tag from 'components/icons/Tag';

const BehavioralDiscountTag = ({ behavioralDiscounts, isPastBasket, isTempo }) => {
  const allBehavioralDiscountsTriggered = behavioralDiscounts.every(bd => bd.discountTriggered);

  const tagText =
    behavioralDiscounts.length > 1
      ? `${behavioralDiscounts.length} Offers`
      : behavioralDiscounts[0].dashboardTagText;

  if (isPastBasket && !allBehavioralDiscountsTriggered) {
    return behavioralDiscounts.map(
      (bd, i) =>
        bd.discountTriggered && (
          <StatusTag
            key={i}
            backgroundColor={isTempo ? 'bg-tempo-blue-50' : 'bg-green-50'}
            icon={<Check className="min-h-3 min-w-3" />}
            text={bd.dashboardTagText}
            textColor={isTempo ? 'text-tempo-blue-90' : 'text-green-100'}
          />
        )
    );
  } else {
    return (
      <StatusTag
        backgroundColor={isTempo ? 'bg-tempo-blue-50' : 'bg-green-50'}
        icon={
          allBehavioralDiscountsTriggered ? (
            <Check className="min-h-3 min-w-3" />
          ) : (
            <Tag className="min-h-3 min-w-3" />
          )
        }
        text={tagText}
        textColor={isTempo ? 'text-tempo-blue-90' : 'text-green-100'}
      />
    );
  }
};

BehavioralDiscountTag.propTypes = {
  behavioralDiscounts: PropTypes.array.isRequired,
  isPastBasket: PropTypes.bool.isRequired,
  isTempo: PropTypes.bool.isRequired,
};

export default BehavioralDiscountTag;
